(function () {
    'use strict';
    var controllerId = 'clienteAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '$filter', 'datacontext', 'common', 'cliente','province', 'comuni', '$translate', clienteAddFn]);

    function clienteAddFn($scope, $uibModalInstance, $filter, datacontext, common, cliente, province, comuni, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.province = province;
        $scope.cliente = cliente;
        $scope.comuni = [];

        $scope.getComuni = getComuni;
 
        $scope.titolo = $translate.instant('Nuovo cliente');

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = {};
                addItem($scope.cliente).then(function (result) {
                    if (result.Id && result.Id > 0)
                        $uibModalInstance.close(result);
                });
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Aggiunta elemento
        function addItem(item) {
            return datacontext.cliente_add(item).then(function (data) {                
                if (!data || data.Id == null || data.Id == 0) {
                    logError($translate.instant('Errore durante la creazione del dato'));
                    return null;
                }

                return data;                                                    
            });
        }

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }
    }
})();